import { components40Names } from "../v40/components.enum";

export const componentsInspectionlessV1Names = components40Names;
